import { render, staticRenderFns } from "./AddPlayerPanel.vue?vue&type=template&id=ad4be43a&"
import script from "./AddPlayerPanel.vue?vue&type=script&lang=js&"
export * from "./AddPlayerPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports